import { useCurrentEntityManager } from "@/stores/entity-store";
import { watch } from "vue";

const allowedEntityTypes = ["domain", "product", "process"];

export const useHtmlTitleManager = () => {
    const { entity } = useCurrentEntityManager();

    watch(
        () => entity.value,
        async (_entity) => {
            if (!_entity) {
                document.title = "MyStekz";
                return;
            }

            if (entity.value.entity_type === "stek") {
                document.title = `≡ ${entity.value.name}`;
                return;
            }

            let ref = _entity;
            const entities = [];
            while (ref?.parent) {
                if (allowedEntityTypes.includes(ref.entity_type)) {
                    entities.push(ref);
                }
                ref = ref.parent;
            }
            entities.reverse();
            if (entities.length === 0) {
                return;
            }

            document.title = entities.map((entity) => entity.name).join(" > ");
        }
    );
};
